import React,{useContext, useState} from 'react'
import './Hero.css'
import {BiLogoWhatsapp,BiLogoFacebook,BiNews, BiMenuAltLeft, BiX} from 'react-icons/bi'
import logo  from '../../assets/1739276909146.jpg'
import { Link, useLocation } from 'react-router-dom'
import { ContactContext } from '../../context/contactContext'
import { DonateContext } from '../../context/donateContext'
import { MenuContext } from '../../context/MenuContext'

const Hero = () => {
  const {setIsContactOpen} = useContext(ContactContext);
  const {setIsDonateOpen} = useContext(DonateContext);
  const {setIsMenuOpen, menuOpen} = useContext(MenuContext);

  const OpenBoard = () =>{
    setIsContactOpen(true)
  }

  const DonateBoard = () =>{
    setIsDonateOpen(true)
  }

  const MenuToggle = () =>{
    setIsMenuOpen(!menuOpen)
  }

  const [menu, setMenu] = useState('Home')

  const location = useLocation();
  if(location.pathname.startsWith('/admin')){
    return null
  }
  
  return (
    <div className='main_holder'>
      <div className="menu_controls">
        {!menuOpen ? (
        <BiMenuAltLeft className='control_opening' onClick={MenuToggle}/>) : (
        <BiX className='control_closing' onClick={MenuToggle}/>
        )
        }
      </div>
      <div className='hero'>
          <img className='logo' src={logo} alt="" />
          <ul>
              <Link to='/' className='linktag'><li onClick={()=> setMenu('Home')} className={menu === 'Home' ? 'active': ''}>Home</li></Link>
              <Link to='/about' className='linktag'><li onClick={()=> setMenu('About')} className={menu === 'About' ? 'active': ''}>About</li></Link>
              <Link to='/volunteer' className='linktag'><li onClick={()=> setMenu('Volunteer')} className={menu === 'Volunteer' ? 'active': ''}>Volunteer</li></Link>
            <Link to='/services' className='linktag'><li onClick={()=> setMenu('Services')} className={menu === 'Services' ? 'active': ''}>Services</li></Link> 
              <Link to='/gallery' className='linktag'><li onClick={()=> setMenu('Gallery')} className={menu === 'Gallery' ? 'active': ''}>Gallery</li></Link>
              <li onClick={OpenBoard} className={menu === 'Contact' ? 'active': ''}>Contact</li>
            
          </ul>
        <div className='appw'>
          <BiLogoWhatsapp className='wbicon' onClick={()=> window.open('https://wa.me/0823499920', ('_blank'))}/>
          <BiLogoFacebook className='fbicon' onClick={()=> window.open('https://www.facebook.com/emthonjenicenter', ('_blank'))}/>
          <Link to='/blog'  className='linktag'><BiNews className='nficon'/></Link>
        </div>

          <button className='donatebtn' onClick={DonateBoard}>Donate</button>
      </div>
      <div className={!menuOpen  ? 'mobile_navbar' : 'openMenu'}>
          <div className="mobile_links">
            <Link to='/' className='linktag'><li onClick={()=> setMenu('Home')} className={menu === 'Home' ? 'mobile_active': ''}>Home</li></Link>
            <Link to='/about' className='linktag'><li onClick={()=> setMenu('About')} className={menu === 'About' ? 'mobile_active': ''}>About</li></Link>
            <Link to='/volunteer' className='linktag'><li onClick={()=> setMenu('Volunteer')} className={menu === 'Volunteer' ? 'mobile_active': ''}>Volunteer</li></Link>
            <Link to='/services' className='linktag'><li onClick={()=> setMenu('Services')} className={menu === 'Services' ? 'mobile_active': ''}>Services</li></Link>
            <Link to='/gallery' className='linktag'><li onClick={()=> setMenu('Gallery')} className={menu === 'Gallery' ? 'mobile_active': ''}>Gallery</li></Link>
            <li onClick={OpenBoard} className={menu === 'Contact' ? 'mobile_active': ''}>Contact</li>
            <button className='donatebtn' onClick={DonateBoard}>Donate</button>
          </div>
      </div>   
    </div>
  )
}

export default Hero